module.exports = __webpack_public_path__ + "img/fileB.9d2ea4c6.png";